module.exports = "<div class=\"ui segment full-height\">\n  <iframe *ngIf=\"announcement?.url\" [src]=\"trustUrl(announcement.url)\"></iframe>\n</div>\n\n<!--{{announcement}}-->"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcement-detail/announcement-detail.component.html
// module id = ../../../../../src/app/announcements/announcement-detail/announcement-detail.component.html
// module chunks = main